import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
import link from './link.js';
var schema = defineObject('menuItem', {
    label: {
        title: 'Label',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    link: {
        title: 'Link',
        type: 'link',
        validation: function validation(Rule) {
            return Rule.required();
        }
    },
    submenuItems: {
        title: 'Submenu Items',
        type: 'array',
        of: [
            {
                type: 'menuItem'
            }
        ]
    }
}, [
    link.schema.link,
    {}
]);
var validator = z.object({
    label: z.string(),
    link: link.validator
}).partial();
schema.menuItem;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=menuItem.js.map